import { render } from "./BranchChart.vue?vue&type=template&id=23bd7c78"
import script from "./BranchChart.vue?vue&type=script&lang=js"
export * from "./BranchChart.vue?vue&type=script&lang=js"

import "./BranchChart.vue?vue&type=style&index=0&id=23bd7c78&lang=scss"
script.render = render

export default script